// extracted by mini-css-extract-plugin
module.exports = {"devButton":"movements_devButton__22OY-"};